export const generateQueryString = (fields: string[]): string => {
    return JSON.stringify(
      {
        query_string: {
          query: fields.map(f => `"${f}"`).join(' OR '),
          fields,
        },
      },
      null,
      2
    );
  }

  export function generatePivotQuery(pivotTitle: string): string {
    switch (pivotTitle) {
      case 'Parent-Child Process Relationship':
        return `
  in(#event_simpleName, values=["ProcessRollup2","SyntheticProcessRollup2"])
  | event_platform=Win
  | ParentBaseFileName=/input.parent_process_path/i or ImageFileName=/input.process_path/i
  | default(field=GrandParentBaseFileName, value="Unknown")
  // CHANGE ME to your base URL for process and graph explorer links
  | rootURL := "https://falcon.us-2.crowdstrike.com/"
  | ProcessStartTime := round(ProcessStartTime)
  | processStart:=formattime(field=ProcessStartTime, format="%m/%d %H:%M:%S")
  // If Context Process ID is available utilize it, if not utilize Target Process ID
  | ContextId:=TargetProcessId
  | ContextId:=ContextProcessId
  // Create URLs for Process and Graph Explorers
  | format("%sinvestigate/process-explorer/%s/%s?_cid=%s", field=["rootURL", "aid", "ContextId", "cid"], as="ProcessExplorer")
  | format("%sgraphs/process-explorer/graph?id=pid:%s:%s", field=["rootURL", "aid", "TargetProcessId"], as="GraphExplorer")
  | table([@timestamp, processStart, ComputerName, UserName, GrandParentBaseFileName, ParentBaseFileName, ImageFileName, CommandLine, ParentProcessId, RawProcessId, TargetProcessId, GraphExplorer, ProcessExplorer])
  | sort(@timestamp, order=asc)`;
  
      case 'Parent-Child ProcessID Relationship':
        return `
  #event_simpleName=/ProcessRollup/i
  | (ParentBaseFileName=/input.parent_process_path/i and SourceProcessId="input.parent_process_id) or (FileName=/input.process_path/i and TargetProcessId="input.process_id)
  | default(field=GrandParentBaseFileName, value="Unknown")
  // CHANGE ME to your base URL for process and graph explorer links
  | rootURL := "https://falcon.us-2.crowdstrike.com/"
  | ProcessStartTime := round(ProcessStartTime)
  | processStart:=formattime(field=ProcessStartTime, format="%m/%d %H:%M:%S")
  | ContextId:=TargetProcessId
  | ContextId:=ContextProcessId
  | format("%sinvestigate/process-explorer/%s/%s?_cid=%s", field=["rootURL", "aid", "ContextId", "cid"], as="ProcessExplorer")
  | format("%sgraphs/process-explorer/graph?id=pid:%s:%s", field=["rootURL", "aid", "TargetProcessId"], as="GraphExplorer")
  | table([@timestamp, processStart, ComputerName, UserName, GrandParentBaseFileName, ParentBaseFileName, ImageFileName, CommandLine, ParentProcessId, RawProcessId, TargetProcessId, GraphExplorer, ProcessExplorer])
  | sort(@timestamp, order=asc)`;
  
      case 'Child - Parent - GrandParent ProcessID':
        return `
  #event_simpleName=/ProcessRollup/i
  | ParentBaseFileName=/input.parent_process_path/i  or FileName=/input.process_path/i or GrandParentBaseFileName=/input.grandparent_process_path/i
  | default(field=GrandParentBaseFileName, value="Unknown")
  // CHANGE ME to your base URL for process and graph explorer links
  | rootURL := "https://falcon.us-2.crowdstrike.com/"
  | ProcessStartTime := round(ProcessStartTime)
  | processStart:=formattime(field=ProcessStartTime, format="%m/%d %H:%M:%S")
  | ContextId:=TargetProcessId
  | ContextId:=ContextProcessId
  | format("%sinvestigate/process-explorer/%s/%s?_cid=%s", field=["rootURL", "aid", "ContextId", "cid"], as="ProcessExplorer")
  | format("%sgraphs/process-explorer/graph?id=pid:%s:%s", field=["rootURL", "aid", "TargetProcessId"], as="GraphExplorer")
  | table([@timestamp, processStart, ComputerName, UserName, GrandParentBaseFileName, ParentBaseFileName, ImageFileName, CommandLine, ParentProcessId, RawProcessId, TargetProcessId, GraphExplorer, ProcessExplorer])
  | sort(@timestamp, order=asc)`;
  
      default:
        return '// No matching pivot title. Please check for typos or update the switch-case.';
    }
  }
  